import LocationIncidentsRoutes from './LocationIncidentsRoutes';

export function LocationIncidentsRoot() {
  return <LocationIncidentsRoutes />;
}

export default LocationIncidentsRoot;
